
/// <reference path="../membershipManager.module.ts" />
module Meevo.Plugins.MembershipManager {

    class ViewBenefitsModalController {

        static $inject = [
            "$filter",
            "$mdDialog",
            "$translate",
            "benefits",
            "membershipModel",
            "enrollmentPackages",
            "recurringPackages",
            "$locale"
        ];

        public currencySymbol = this.$locale.NUMBER_FORMATS.CURRENCY_SYM;

        constructor(
            protected $filter: angular.IFilterService,
            protected $mdDialog: angular.material.IDialogService,
            protected $translate: angular.translate.ITranslateService,
            public benefits: any,
            public membershipModel: any,
            public enrollmentPackages: any,
            public recurringPackages:any,
            public $locale: angular.ILocaleService) {}

        close = () => {
            this.$mdDialog.hide({ status: false });
        };

        calculatePercents(amount): number {
            return amount ? Math.floor(amount * 100) : 0;
        }
    }


    angular.module("meevo.plugins.membershipManager")
        .controller("meevo.plugins.membershipManager.ViewBenefitsModalController", ViewBenefitsModalController);
}